import './LegalPage.css';

export default function TermsPage() {
  const handleBack = () => {
    if (window.history.length > 1) window.history.back();
    else window.close();
  };

  return (
    <div className="legal-page">
      <header className="legal-header">
        <button className="legal-back-btn" onClick={handleBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <span className="legal-title">이용약관</span>
      </header>

      <div className="legal-body">
        <p className="legal-date">시행일: 2026년 3월 2일</p>

        <h2>제1조 (목적)</h2>
        <p>이 약관은 인생로그(이하 "서비스")가 제공하는 인생 기록 서비스의 이용조건 및 절차, 이용자와 서비스 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>

        <h2>제2조 (정의)</h2>
        <ul>
          <li>"서비스"란 인생로그가 제공하는 웹 기반 인생 기록·관리 서비스를 말합니다.</li>
          <li>"이용자"란 이 약관에 따라 서비스를 이용하는 회원을 말합니다.</li>
          <li>"기록"이란 이용자가 서비스에 저장하는 텍스트, 사진, 위치 정보 등의 콘텐츠를 말합니다.</li>
        </ul>

        <h2>제3조 (약관의 효력 및 변경)</h2>
        <ul>
          <li>이 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
          <li>서비스는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 변경할 수 있으며, 변경된 약관은 공지 후 효력이 발생합니다.</li>
        </ul>

        <h2>제4조 (회원가입 및 탈퇴)</h2>
        <ul>
          <li>이용자는 이메일 또는 소셜 로그인(카카오, 구글)을 통해 회원가입할 수 있습니다.</li>
          <li>이용자는 언제든지 설정 메뉴를 통해 회원 탈퇴를 요청할 수 있으며, 탈퇴 즉시 모든 데이터가 삭제됩니다.</li>
          <li>탈퇴 후 삭제된 데이터는 복구할 수 없습니다.</li>
        </ul>

        <h2>제5조 (서비스의 제공 및 변경)</h2>
        <ul>
          <li>서비스는 다음의 기능을 제공합니다:
            <ul>
              <li>인생 기록 작성, 수정, 삭제</li>
              <li>카테고리별 기록 분류</li>
              <li>프로필별 기록 관리</li>
              <li>기록 공유 (링크 공유, 카카오톡 공유)</li>
              <li>타임라인 및 추억 보기</li>
              <li>데이터 백업 및 복원</li>
            </ul>
          </li>
          <li>서비스는 운영상, 기술상의 필요에 따라 제공하는 서비스를 변경할 수 있습니다.</li>
        </ul>

        <h2>제6조 (이용자의 의무)</h2>
        <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
        <ul>
          <li>타인의 개인정보를 도용하는 행위</li>
          <li>서비스의 안정적 운영을 방해하는 행위</li>
          <li>서비스를 이용하여 법령 또는 공서양속에 반하는 행위</li>
          <li>다른 이용자의 서비스 이용을 방해하는 행위</li>
          <li>서비스의 기술적 보호조치를 회피하거나 무력화하는 행위</li>
        </ul>

        <h2>제7조 (콘텐츠의 권리 및 책임)</h2>
        <ul>
          <li>이용자가 작성한 기록의 저작권은 해당 이용자에게 귀속됩니다.</li>
          <li>서비스는 이용자의 기록을 서비스 제공 목적 외에 사용하지 않습니다.</li>
          <li>이용자는 자신이 업로드하는 콘텐츠에 대한 법적 책임을 집니다.</li>
        </ul>

        <h2>제8조 (서비스의 중단)</h2>
        <p>서비스는 다음의 경우 서비스 제공을 일시적으로 중단할 수 있습니다.</p>
        <ul>
          <li>시스템 정기 점검, 서버 확충 및 교체 등의 경우</li>
          <li>천재지변, 정전, 장비 장애 등 불가항력적인 사유가 발생한 경우</li>
          <li>서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우</li>
        </ul>

        <h2>제9조 (면책조항)</h2>
        <ul>
          <li>서비스는 무료로 제공되며, 서비스 이용과 관련하여 서비스에 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.</li>
          <li>서비스는 이용자가 서비스를 이용하여 기대하는 결과를 얻지 못하거나, 서비스를 통해 얻은 자료로 인한 손해에 대해 책임을 지지 않습니다.</li>
          <li>서비스는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</li>
        </ul>

        <h2>제10조 (분쟁 해결)</h2>
        <ul>
          <li>서비스 이용과 관련하여 분쟁이 발생한 경우, 양 당사자는 원만한 해결을 위해 성실히 협의합니다.</li>
          <li>분쟁에 관한 소송은 대한민국 법률에 따르며, 관할 법원은 민사소송법에 따릅니다.</li>
        </ul>

        <h2>부칙</h2>
        <p>이 약관은 2026년 3월 2일부터 시행합니다.</p>
      </div>
    </div>
  );
}
